// @flow
export const INSTALL_HUB_STAGES_GOOD_PLACEMENT = 'hive/installHub/INSTALL_HUB_STAGES_GOOD_PLACEMENT';
export const INSTALL_HUB_STAGES_BAD_PLACEMENT = 'hive/installHub/INSTALL_HUB_STAGES_BAD_PLACEMENT';
export const INSTALL_HUB_STAGES_INSTALL = 'hive/installHub/INSTALL_HUB_STAGES_INSTALL';
export const INSTALL_HUB_STAGES = [
    INSTALL_HUB_STAGES_GOOD_PLACEMENT,
    INSTALL_HUB_STAGES_BAD_PLACEMENT,
    INSTALL_HUB_STAGES_INSTALL
];

// Constants
export const ATTEMPT_CLAIM_HUB = 'hive/installHub/ATTEMPT_CLAIM_HUB';
export const PROGRESS_INSTALL_STAGE = 'hive/installHub/PROGRESS_INSTALL_STAGE';
export const CLAIM_HUB = 'hive/installHub/CLAIM_HUB';
export const RESET_CLAIM_HUB_ERROR = 'hive/installHub/RESET_CLAIM_HUB_ERROR';



// WEBPACK FOOTER //
// ./src/core/state/install-hub/constants.js